import React from "react";
import styled from "styled-components";
import { vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import { getAssetURL } from "../../helpers/assets";

export type TextWithBackgroundImageProps = {
  isPublished?: boolean;
  content: string;
  background_image: {
    id: string;
    filename_disk: string;
  };
  icon_image?: {
    id: string;
    filename_disk: string;
  };
  icon_image_alt_text?: string;
};

export default function TextWithBackgroundImage(
  props: TextWithBackgroundImageProps,
): JSX.Element | null {
  return (
    <Container
      backgroundUrl={getAssetURL(props?.background_image)}
    >
      <Title
        dangerouslySetInnerHTML={{
          __html: props.content,
        }}
      />
      {props?.icon_image && (
        <Icon
          src={getAssetURL(props?.icon_image)}
          alt={props?.icon_image_alt_text}
        />
      )}
    </Container>
  );
}

const Container = styled.section<{
  backgroundUrl?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${vwMobile(60)};
  padding: ${vwMobile(90)} ${vwMobile(26)};
  background-color: var(--color-alt-green-03);
  background-image: url(${(props) => props.backgroundUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  color: var(--color-white);

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${vwDesktop(40)};
    padding: ${vwDesktop(130)};
  }
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-inline: auto;
  max-width: ${vwMobile(155)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    max-width: ${vwDesktop(335)};
  }
`;

const Title = styled.h1`
  font-size: ${vwMobile(42)};
  line-height: 0.92;
  letter-spacing: 0.03em;
  font-weight: 900;
  text-align: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${vwDesktop(108)};
  }
`;
